import reactLogo from '../img/logofot.png'

export const ReactLogo = () => {
    return (
        <img src={reactLogo}
            alt="React Logo"
            style={{
                position: 'fixed',
                bottom: '65px',
                right: '10px',
                width: '100px'
            }}
        />
    )
}